import { getApiBaseUrl } from '../data/authStorage';
import httpClient from './httpClient';

const baseUrl = getApiBaseUrl();
export const NOTIFICATION_INBOX_CHANGED_EVENT = "cehr:notification-inbox-changed";

const notifyInboxChanged = () => {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(NOTIFICATION_INBOX_CHANGED_EVENT));
};

/**
 * Create a new notification
 */
export async function createNotification(payload) {
  try {
    const response = await httpClient.post(
      `${baseUrl}/organizations/notifications`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

/**
 * List all notifications for the organization
 */
export async function listNotifications(params = {}) {
  try {
    const { limit = 15, page = 1 } = params;
    const response = await httpClient.get(
      `${baseUrl}/organizations/notifications?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

/**
 * List notifications for the authenticated employee, or staff inbox
 */
export async function listMyNotifications(params = {}) {
  try {
    const { limit = 15, page = 1 } = params;
    const response = await httpClient.get(
      `${baseUrl}/organizations/notifications/my?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

/**
 * Mark an authenticated employee notification as read
 */
export async function markMyNotificationAsRead(notificationId) {
  try {
    const response = await httpClient.patch(
      `${baseUrl}/organizations/notifications/my/${notificationId}/read`
    );
    notifyInboxChanged();
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function markAllMyNotificationsAsRead() {
  try {
    const response = await httpClient.patch(`${baseUrl}/organizations/notifications/my/read-all`);
    notifyInboxChanged();
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function updateMyNotificationPreferences(retentionMonths) {
  try {
    const response = await httpClient.patch(`${baseUrl}/organizations/notifications/my/preferences`, { retentionMonths });
    notifyInboxChanged();
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function deleteMyNotification(notificationId) {
  try {
    const response = await httpClient.delete(
      `${baseUrl}/organizations/notifications/my/${notificationId}`
    );
    notifyInboxChanged();
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

/**
 * Get a single notification by ID
 */
export async function getNotificationById(notificationId) {
  try {
    const response = await httpClient.get(
      `${baseUrl}/organizations/notifications/${notificationId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

/**
 * Send or schedule a notification
 */
export async function sendNotification(notificationId, status) {
  try {
    const response = await httpClient.patch(
      `${baseUrl}/organizations/notifications/${notificationId}/send`,
      { status }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

/**
 * Delete a notification
 */
export async function deleteNotification(notificationId) {
  try {
    const response = await httpClient.delete(
      `${baseUrl}/organizations/notifications/${notificationId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}
